export function mentionPattern() {
  return /!\[\[([^\]\n]+)\]\]|([@+#])(?:\[([^\]\n]+)\]|([\p{L}\p{N}_][\p{L}\p{N}_'-]*))/gu
}

export function matchedEntity(match) {
  const [, embedded, sigil, bracketed, bare] = match
  return embedded ? store.resolveAny(embedded) : store.resolveEntity(sigil, bracketed || bare)
}

export const SIGIL_KINDS = {
  "@": ["character", "item", "faction", "other"],
  "+": ["location"],
  "#": ["thread"]
}

export const store = {
  documents: [],
  entities: [],
  projects: [],
  urls: {},
  highlighted: new Set(),

  init({ documents, entities, projects, urls }) {
    this.documents = documents
    this.entities = entities
    this.projects = projects || []
    this.urls = urls
    this.highlighted = new Set()
  },

  resolveAny(name) {
    const wanted = name.toLowerCase().trim()
    return this.entities.find((entity) => entity.name.toLowerCase() === wanted) || null
  },

  toggleHighlight(id) {
    this.highlighted.has(id) ? this.highlighted.delete(id) : this.highlighted.add(id)
  },

  resolveEntity(sigil, name) {
    const wanted = name.toLowerCase().trim()
    const matches = this.entities.filter((entity) => entity.name.toLowerCase() === wanted)
    const kinds = SIGIL_KINDS[sigil] || []
    return matches.find((entity) => kinds.includes(entity.kind)) || matches[0] || null
  },

  findEntity(id) {
    return this.entities.find((entity) => entity.id === Number(id)) || null
  },

  upsertEntity(entity) {
    const index = this.entities.findIndex((existing) => existing.id === entity.id)
    if (index >= 0) this.entities[index] = entity
    else this.entities.push(entity)
    this.entities.sort((a, b) => a.name.localeCompare(b.name))
    return entity
  },

  updateDocument(doc) {
    const existing = this.documents.find((d) => d.id === doc.id)
    if (existing) Object.assign(existing, doc)
  }
}

export function timeAgo(date) {
  const seconds = Math.max(0, (Date.now() - date.getTime()) / 1000)
  if (seconds < 90) return "just now"
  const minutes = Math.round(seconds / 60)
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.round(hours / 24)
  return days === 1 ? "yesterday" : `${days}d ago`
}

export function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content
}

export async function api(url, { method = "GET", body } = {}) {
  const response = await fetch(url, {
    method,
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-CSRF-Token": csrfToken()
    },
    body: body ? JSON.stringify(body) : undefined
  })
  if (!response.ok) throw new Error(`${method} ${url} → ${response.status}`)
  return response.json()
}
